import styled from "styled-components";
import banner from "../../images/loginbannerimage.png";
import loginBanner from "../../images/loginBanner.jpg" // Import your mobile banner image

export const FormWrapper = styled.div`
  margin-block: 22px;
  font-family: 'Poppins', sans-serif;
  .inputBox {
    max-width: 860px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: start;
    gap: 20px;

    & > div {
      margin-bottom: 0;
      min-width: 0;

      &.min-w100 {
        grid-column: 1 / -1;
      }
    }

    .otp-input {
      max-width: 100%;
    }

    &.panBox {
      width: 100%;
      max-width: 100%;
      display: block;
    }
  }

  .incomeBox {
    max-width: 420px;
    margin-top: 30px;
  }

  /* PAN input cells */
  .panBox input,
  .panBox .otp-input input {
    border: 1.5px solid #d8eed2 !important;
    border-radius: 10px !important;
    background: #f8fbf6 !important;
    color: #1C2634 !important;
    font-weight: 700;
    font-size: 18px !important;
    transition: all 0.2s !important;
  }
  .panBox input:focus,
  .panBox .otp-input input:focus {
    border-color: #509540 !important;
    background: #fff !important;
    box-shadow: 0 0 0 3px rgba(80,149,64,0.12) !important;
  }

  /* Standard inputs */
  input[type="text"],
  input[type="number"],
  input[type="email"],
  input[type="tel"],
  select,
  textarea {
    border-radius: 10px;
    transition: border-color 0.2s, box-shadow 0.2s;
    font-family: 'Poppins', sans-serif;
  }

  label {
    color: #1C2634 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
  }

  .button {
    max-width: 320px;
    width: 100%;
    margin-top: 26px;
  }

  .subheading {
    font-size: 20px;
    color: #1C2634;
    line-height: 1.3;
    font-weight: 800;

    &.small {
      font-size: 14px !important;
    }
  }

  @media only screen and (max-width: 540px) {
    .button {
      max-width: 100%;
    }
    .inputBox {
      grid-template-columns: 1fr;
      & > div {
        max-width: 100%;
        width: 100%;
      }
    }
  }
`;


export const FormWrapper2 = styled.div`
      margin-block: 28px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

  .inputBox {
    max-width: 640px;
  

    & > div {
      flex: 1 1 240px;
      margin-bottom: 0;
      max-width: calc(50% - 10px);

      &.min-w100 {
        min-width: 100%;
      }
    }

    .otp-input {
      max-width: 100%;
    }

    &.panBox {
      width: 100%;
      max-width: 100%;
    }
  }

  .button {
    flex: 1 1 100%;
    width: 100%;
    max-width: 100%;
    margin-top: 14px;

    button {
      max-width: 300px;
    }
  }

  .subheading {
    font-size: 25px;
    color: #1C2634;
    line-height: 30px;
    font-weight: 600;

    &.small {
      font-size: 14px !important;
    }
  }

  @media only screen and (max-width: 540px) {
    .button {
      max-width: 100%;
    }
    .inputBox {
      & > div {
        max-width: 100%;
        width: 100%;
      }
    }
  }
`;